import { render, staticRenderFns } from "./CorrectionAnalysisMobile.vue?vue&type=template&id=4fc13a00&scoped=true"
import script from "./CorrectionAnalysisMobile.vue?vue&type=script&lang=js"
export * from "./CorrectionAnalysisMobile.vue?vue&type=script&lang=js"
import style0 from "./CorrectionAnalysisMobile.vue?vue&type=style&index=0&id=4fc13a00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc13a00",
  null
  
)

export default component.exports